(function () {
  "use strict";

  var KEYS = ["gclid", "gbraid", "wbraid"];
  var STORAGE_PREFIX = "sg_ads_";
  var STORAGE_DAYS = 90;

  function readQuery() {
    var params = new URLSearchParams(window.location.search);
    var out = {};
    KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) out[key] = value;
    });
    return out;
  }

  function storeParams(params) {
    var expires = Date.now() + STORAGE_DAYS * 24 * 60 * 60 * 1000;
    KEYS.forEach(function (key) {
      if (!params[key]) return;
      try {
        localStorage.setItem(STORAGE_PREFIX + key, params[key]);
        localStorage.setItem(STORAGE_PREFIX + key + "_exp", String(expires));
        sessionStorage.setItem(STORAGE_PREFIX + key, params[key]);
      } catch (e) {
        /* ignore */
      }
    });
  }

  function readStored() {
    var out = {};
    KEYS.forEach(function (key) {
      try {
        var exp = parseInt(localStorage.getItem(STORAGE_PREFIX + key + "_exp") || "0", 10);
        var value = localStorage.getItem(STORAGE_PREFIX + key);
        if (value && (!exp || exp > Date.now())) {
          out[key] = value;
        }
      } catch (e) {
        /* ignore */
      }
    });
    return out;
  }

  function pushDataLayer(event, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, payload || {}));
  }

  function syncCartAttributes(params) {
    if (!params.gclid && !params.gbraid && !params.wbraid) return;
    var attributes = {};
    if (params.gclid) attributes.gclid = params.gclid;
    if (params.gbraid) attributes.gbraid = params.gbraid;
    if (params.wbraid) attributes.wbraid = params.wbraid;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () {
      /* non-blocking */
    });
  }

  var incoming = readQuery();
  if (Object.keys(incoming).length) {
    storeParams(incoming);
    pushDataLayer("sg_ads_click_params", incoming);
  }

  var stored = readStored();
  var active = Object.keys(incoming).length ? incoming : stored;
  if (active.gclid || active.gbraid || active.wbraid) {
    pushDataLayer("sg_ads_attribution_ready", active);
    syncCartAttributes(active);
  }
})();